module.exports = require('./lib/Diagram');


// WEBPACK FOOTER //
// ./~/diagram-js/index.js